import { useRef, useState } from "react";
import * as formService from '../../form-services/cancellation-editor';
import { useEventNotification } from "../../../../framework/services/event-notification";
import { IProjectCancellationPanelLaunchArgs } from "../../entities/cancellation-args";
import { ProjectEvents } from "../../events";
import { BwjButtonType } from "../../../../framework/components/bwj-button";
import { BwjGrid, Row, Col } from "../../../../framework/components/bwj-layout";
import { Spacing } from "../../../../framework/components/bwj-layout/styles";
import { BwjSidePanel } from "../../../../framework/components/bwj-side-panel";
import { BwjTextField } from "../../../../framework/components/bwj-text-field";

interface IProjectCancellationPanelProps {
  onProceedWithAction: (projectId: string) => void;
}

const subscriberId = 'Panel.ProjectCancellation';

export const ProjectCancellationPanel: React.FunctionComponent<IProjectCancellationPanelProps> = (props) => {
  const [showPanel, setShowPanel] = useState(false);
  const formModel = formService.useFormModel(subscriberId);
  const hasUnsavedChanges = formService.useHasUnsavedChanges(formModel, false);
  const args = useRef<IProjectCancellationPanelLaunchArgs>({ id: '', title: '' });

  useEventNotification((panelArgs: IProjectCancellationPanelLaunchArgs) => {
    args.current = panelArgs;
    formService.initializeService({});
    setShowPanel(true);
  }, [], ProjectEvents.ProjectCancellationPanel_Launch, subscriberId);

  const onClosePanel = () => setShowPanel(false);

  const onSaveChanges = () => {
    formService.validateAndUpdateModel()
    .then(result => {
      if(result.isValid) {
        props.onProceedWithAction(args.current.id);
        onClosePanel();
      }
    });
  }

  return (
    <BwjSidePanel
      showPanel={showPanel}
      title={args.current.title}
      footerButtons={[{
        buttonStyle: BwjButtonType.PrimaryStandard,
        text: 'Proceed',
        disabled: hasUnsavedChanges === false,
        onClick: onSaveChanges
      }, {
        buttonStyle: BwjButtonType.DefaultStandard,
        text: 'Cancel',
        onClick: onClosePanel
      }]}
      onDismiss={onClosePanel}
    >
      <BwjGrid>
        <Row bottomSpacing={Spacing.Large}>
          <Col small={12}>
            <BwjTextField
              id={formService.rationale.id}
              required={true}
              label={formService.rationale.description}
              onUpdate={formService.rationale.onUpdate}
              input={formModel.rationale}
              multiline={true}
            />
          </Col>
        </Row>
      </BwjGrid>
    </BwjSidePanel>
  );
};